interface RBG {
  r: number;
  g: number;
  b: number;
}

/**
 * Flatten the color with opacity
 * @param color
 * @param opacity
 */
export const flatten = (color: string, opacity: number): string => {
  const fgColor = hexToRGB(color);
  const bgColor = {r: 255, g: 255, b: 255}; // white

  const flattenedColor = {
    r: Math.round(opacity * fgColor.r + (1 - opacity) * bgColor.r),
    g: Math.round(opacity * fgColor.g + (1 - opacity) * bgColor.g),
    b: Math.round(opacity * fgColor.b + (1 - opacity) * bgColor.b),
  };

  return `rgb(${flattenedColor.r},${flattenedColor.g},${flattenedColor.b})`;
};

/**
 * Translate hex code to rgb code
 * @param color
 */
const hexToRGB = (color: string): RBG => {
  const rgb = {
    r: +('0x' + color[1] + color[2]),
    g: +('0x' + color[3] + color[4]),
    b: +('0x' + color[5] + color[6]),
  };

  return rgb;
};
